const WorkProcessOne = () => {
  return (
    <section className='tutor-two py-120 position-relative z-1 half-bg half-bg__64 style-two'>
      <div className='container'>
        <div className='section-heading text-center'>
          <div className='flex-align d-inline-flex gap-8 mb-16 wow bounceInDown'>
            <span className='text-main-600 text-2xl d-flex'>
              <i className='ph-bold ph-book-open' />
            </span>
            <h5 className='text-main-600 mb-0'>Working Process</h5>
          </div>
          <h2 className='mb-24 wow bounceIn'>How It Works For Tutors</h2>
          <p className=' wow bounceInUp'>
            Our tutoring sessions are interactive and engaging, focusing on the
            student's specific needs.
          </p>
        </div>
        <div className='row gy-4'>
          <div
            className='col-xxl-3 col-sm-6'
            data-aos='fade-up'
            data-aos-duration={200}
          >
            <div className='bg-white border border-neutral-30 animation-item rounded-16 p-16 item-hover text-center'>
              <div className='bg-main-25 p-24 rounded-16 item-hover__bg-main transition-2'>
                <div className='w-136 h-136 bg-white p-16 box-shadow-md rounded-circle mx-auto d-inline-flex align-items-center justify-content-center position-relative'>
                  <span className='border border-main-600 border-dashed rounded-circle w-100 h-100 flex-center'>
                    <img
                      src='assets/images/icons/work-process-icon1.png'
                      alt=''
                      className='animate__flipInY'
                    />
                  </span>
                  <span className='w-40 h-40 flex-center rounded-circle bg-main-600 text-white text-lg position-absolute top-n6 end-n4 box-shadow-md item-hover__bg item-hover__text-main transition-2'>
                    01
                  </span>
                </div>
                <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                  College Tutoring
                </h4>
                <p className='text-sm text-neutral-500 item-hover__text transition-2 mt-16'>
                  This helps us adjust the learning plan as needed keep{" "}
                </p>
              </div>
            </div>
          </div>
          <div
            className='col-xxl-3 col-sm-6'
            data-aos='fade-up'
            data-aos-duration={400}
          >
            <div className='bg-white border border-neutral-30 animation-item rounded-16 p-16 item-hover text-center'>
              <div className='bg-main-25 p-24 rounded-16 item-hover__bg-main transition-2'>
                <div className='w-136 h-136 bg-white p-16 box-shadow-md rounded-circle mx-auto d-inline-flex align-items-center justify-content-center position-relative'>
                  <span className='border border-main-600 border-dashed rounded-circle w-100 h-100 flex-center'>
                    <img
                      src='assets/images/icons/work-process-icon2.png'
                      alt=''
                      className='animate__flipInY'
                    />
                  </span>
                  <span className='w-40 h-40 flex-center rounded-circle bg-main-600 text-white text-lg position-absolute top-n6 end-n4 box-shadow-md item-hover__bg item-hover__text-main transition-2'>
                    02
                  </span>
                </div>
                <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                  Set Schedule
                </h4>
                <p className='text-sm text-neutral-500 item-hover__text transition-2 mt-16'>
                  This helps us adjust the learning plan as needed keep{" "}
                </p>
              </div>
            </div>
          </div>
          <div
            className='col-xxl-3 col-sm-6'
            data-aos='fade-up'
            data-aos-duration={600}
          >
            <div className='bg-white border border-neutral-30 animation-item rounded-16 p-16 item-hover text-center'>
              <div className='bg-main-25 p-24 rounded-16 item-hover__bg-main transition-2'>
                <div className='w-136 h-136 bg-white p-16 box-shadow-md rounded-circle mx-auto d-inline-flex align-items-center justify-content-center position-relative'>
                  <span className='border border-main-600 border-dashed rounded-circle w-100 h-100 flex-center'>
                    <img
                      src='assets/images/icons/work-process-icon3.png'
                      alt=''
                      className='animate__flipInY'
                    />
                  </span>
                  <span className='w-40 h-40 flex-center rounded-circle bg-main-600 text-white text-lg position-absolute top-n6 end-n4 box-shadow-md item-hover__bg item-hover__text-main transition-2'>
                    03
                  </span>
                </div>
                <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                  Applying Tuition
                </h4>
                <p className='text-sm text-neutral-500 item-hover__text transition-2 mt-16'>
                  This helps us adjust the learning plan as needed keep{" "}
                </p>
              </div>
            </div>
          </div>
          <div
            className='col-xxl-3 col-sm-6'
            data-aos='fade-up'
            data-aos-duration={800}
          >
            <div className='bg-white border border-neutral-30 animation-item rounded-16 p-16 item-hover text-center'>
              <div className='bg-main-25 p-24 rounded-16 item-hover__bg-main transition-2'>
                <div className='w-136 h-136 bg-white p-16 box-shadow-md rounded-circle mx-auto d-inline-flex align-items-center justify-content-center position-relative'>
                  <span className='border border-main-600 border-dashed rounded-circle w-100 h-100 flex-center'>
                    <img
                      src='assets/images/icons/work-process-icon4.png'
                      alt=''
                      className='animate__flipInY'
                    />
                  </span>
                  <span className='w-40 h-40 flex-center rounded-circle bg-main-600 text-white text-lg position-absolute top-n6 end-n4 box-shadow-md item-hover__bg item-hover__text-main transition-2'>
                    04
                  </span>
                </div>
                <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                  Start Journey
                </h4>
                <p className='text-sm text-neutral-500 item-hover__text transition-2 mt-16'>
                  This helps us adjust the learning plan as needed keep{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkProcessOne;
